import React from 'react'

const TrackingIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={40}
                height={40}
                x={0}
                y={0}
                viewBox="0 0 30 30"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <path
                        d="M20.621 20.015c-.646-.156-.881.811-.242.971 2.2.548 3.621 1.414 3.621 2.206C24 24.518 20.151 26 15 26s-9-1.482-9-2.808c0-.792 1.421-1.659 3.621-2.207.64-.16.403-1.127-.242-.971C6.555 20.719 5 21.848 5 23.192 5 25.666 10.152 27 15 27s10-1.334 10-3.808c0-1.344-1.555-2.473-4.379-3.177zM15 13c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3zm0-5c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM24.07 12.264a3.223 3.223 0 0 0 0-4.527c-.465-.47-1.176.234-.71.704a2.22 2.22 0 0 1 0 3.119c-.472.476.251 1.167.71.704zM6.64 11.56a2.224 2.224 0 0 1 0-3.12c.465-.47-.243-1.173-.71-.704a3.223 3.223 0 0 0 0 4.527c.465.47 1.176-.233.71-.703z"
                        fill="#092C4C"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                    <path
                        d="M26.128 5.442c-.466-.47-1.175.235-.71.704 2.105 2.125 2.105 5.583 0 7.708-.472.476.251 1.167.71.704 2.491-2.513 2.491-6.603 0-9.116zM3.872 5.442c-2.49 2.513-2.49 6.603 0 9.116.459.463 1.182-.228.71-.704-2.105-2.125-2.105-5.583 0-7.708.465-.47-.245-1.173-.71-.704zM14.562 23.741a.5.5 0 0 0 .876 0C20.524 14.003 22 13.012 22 10c0-3.86-3.14-7-7-7s-7 3.14-7 7c0 3.014 1.405 3.866 6.562 13.741zM15 4c3.309 0 6 2.691 6 6 0 2.607-1.192 3.274-6 12.462C10.197 13.285 9 12.608 9 10c0-3.309 2.691-6 6-6z"
                        fill="#092C4C"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                </g>
            </svg>



        </>
    )
}

export default TrackingIcon